import React from "react";
import { TransformationsContainer } from "../../../containers";
const Transformations = (props) => {
  return <TransformationsContainer />;
};

export default Transformations;
